import { render, staticRenderFns } from "./TheMoneyCompensationsListView.vue?vue&type=template&id=0150cad5&"
import script from "./TheMoneyCompensationsListView.vue?vue&type=script&lang=js&"
export * from "./TheMoneyCompensationsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports